import UgcSocialFooter from './UgcSocialFooter';

export default UgcSocialFooter;
